module.exports = __webpack_public_path__ + "b6b81903f863832fd2089e933f2d28b7.jpg";